import { KeyboardArrowLeft, UploadFile } from '@mui/icons-material';
import { Button } from '@mui/material';
import { Box } from '@mui/system';
import { useSelector } from 'react-redux';

type Props = {
  activeStep: any;
  handleBack: any;
  handleUploadSignFile: any;
  uploadedDoc: any;
  handelNavigateBack: any;
};

const PreviewSignatureDocument = (props: Props) => {
  const { activeStep, handleBack, handleUploadSignFile, uploadedDoc, handelNavigateBack } = props;
  const saveMiscDocResponse = useSelector((state: any) => state.saveMiscellaneousDocumentsReducer);

  return (
    <>
      <Box
        sx={{
          border: '1px solid #F2F4F7',
          borderRadius: '20px',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          height: '100%',
        }}
        p={1}
      >
        <Box sx={{ height: '100%' }}>
          {URL.createObjectURL(uploadedDoc) && (
            <Box style={{ height: '100%', width: '100%' }}>
              <iframe
                src={URL.createObjectURL(uploadedDoc)}
                frameBorder="0"
                title="Preview Document"
                width={'100%'}
                height={'100%'}
                style={{ border: 'none' }}
              />
            </Box>
          )}
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
          <Box>
            <Button
              variant="outlined"
              disabled={activeStep === 0}
              startIcon={<KeyboardArrowLeft />}
              onClick={handleBack}
            >
              Back
            </Button>
          </Box>
          <Box>
            <Button
              sx={{ mr: 2, color: '#384250' }}
              onClick={handelNavigateBack}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              startIcon={<UploadFile />}
              onClick={handleUploadSignFile}
              disabled={saveMiscDocResponse?.loading}
            >
              Upload File
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default PreviewSignatureDocument;
